/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/jsx-filename-extension */
import { HomeOutlined } from '@ant-design/icons';
import * as PredioOax from 'views/Catastro/PrediosOaxaca';
import * as NotariosPredios from 'views/Catastro/NotariosPredios';
import * as PeritosPredios from 'views/Catastro/PeritosPredios';
import * as TiposDeDocumentosTraslacion from 'views/Catastro/TiposDeDocumentosTraslacion';
import * as ReportesDeCatastro from 'views/Catastro/ReportesDeCatastro';
import * as CodigosPostales from 'views/Catastro/CodigosPostales';
import UnidadesResponsables from 'views/Configuracion/UnidadesResponsables';
import * as CargaMasivaTramites from 'views/Catastro/CargaMasivaTramites';
import * as ValoresDeTerrenoYConstruccion from 'views/Catastro/ValoresDeTerrenoYConstruccion';

export default {
  title: 'Catastro',
  icon: () => <HomeOutlined />,
  showInSidebar: true,
  type: 'private',
  permissionModel: 'predio',
  children: [
    {
      title: 'Predios',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: PredioOax.default,
      permissionConfig: PredioOax.permissionConfig,
    },
    {
      title: 'Reportes de Catastro',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: ReportesDeCatastro.default,
      permissionConfig: ReportesDeCatastro.permissionConfig,
    },
    {
      title: 'Notarios',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: NotariosPredios.default,
      permissionConfig: NotariosPredios.permissionConfig,
    },
    {
      title: 'Peritos',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: PeritosPredios.default,
      permissionConfig: PeritosPredios.permissionConfig,
    },
    {
      title: 'Tipos de Documentos de Traslación',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: TiposDeDocumentosTraslacion.default,
      permissionConfig: TiposDeDocumentosTraslacion.permissionConfig,
    },
    {
      title: 'Dependencias',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: UnidadesResponsables,
      permissionModel: 'unidadoperativa',
    },
    {
      title: 'Carga Masiva Trámites',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: CargaMasivaTramites.default,
      permissionConfig: CargaMasivaTramites.permissionConfig,
    },
    {
      title: 'Colonias',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: CodigosPostales.default,
      permissionConfig: CodigosPostales.permissionConfig,
    },
    {
      title: 'Valores De Terreno Y Construcción',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: ValoresDeTerrenoYConstruccion.default,
      permissionConfig: ValoresDeTerrenoYConstruccion.permissionConfig,
    },
  ].filter((e) => e),
};
